import Box from '@mui/material/Box'
import { reExportedColors, ITooltip } from '../../index'
import { useNavigate } from 'react-router-dom'
import CloseFullView from '../../Icons/js/CloseFullView'

const GoBackButton = ({ className, onClick }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) return onClick()
    navigate(-1)
  }

  return (
    <Box
      className={`go-back ${className || ''}`}
      onClick={handleClick}
      sx={{
        alignItems: 'center',
        backgroundColor: reExportedColors.MEDIUM_GREY,
        borderRadius: '4px 0px 0px 4px',
        boxShadow: '0px 0px 3px #00000029',
        cursor: 'pointer',
        display: 'flex',
        height: 35,
        justifyContent: 'center',
        marginLeft: '20px',
        transition: 'all 0.2s ease-in-out',
        width: 28
      }}
    >
      <ITooltip placement='top-end' content='Go back'>
        <CloseFullView width={18} height={13} />
      </ITooltip>
    </Box>
  )
}

export default GoBackButton
